export const GlassCard = ({ children, className = '', ...props }) => (
  <div
    className={`bg-[#2D2D52]/40 backdrop-blur-xl border border-white/5 shadow-[0_8px_32px_0_rgba(0,0,0,0.4)] rounded-2xl transition-all duration-300 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
